import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let refreshEmbeddedSection = useDataChange({
    context: 'global',
    path: 'refresh_embedded_section',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return function onClick() {
    setFlowTo(normalizePath(props.viewPath, '../../../../../No'))
    refreshEmbeddedSection(Date.now())
    // reset treatment id
    change(next => {
      next.selected.payments_treatment_plan.treatment_id = null
    })
  }
}
